import styled from 'styled-components';
import { Button } from 'components';

export const Wrapper = styled.div`
  position: absolute;
  width: 100%;
  height: calc(100vh - 70px);
  top: 0px;
`;

interface CodeProps {
  subPage?: boolean;
}

export const Code = styled.h1<CodeProps>`
  text-align: center;
  margin-top: ${props => (props.subPage ? '100px' : '220px')};
  font-size: 120px;
  font-weight: bold;
  pointer-events: none;
  margin-bottom: 20px;
`;

interface MessageProps {
  small?: boolean;
}

export const Message = styled.p<MessageProps>`
  text-align: center;
  font-size: ${props => (props.small ? '18px' : '22px')};
  font-weight: 600;
`;

export const ButtonStyled = styled(Button)`
  margin: ${props => props.theme.spacing.medium};
`;
